import { Container } from '@mui/material';
import React, { useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { defineMessages, useIntl } from 'react-intl';

import { ErrorBoundaryFallback } from '@components/ErrorBoundaryFallback';
import ViewTab from '@components/ViewTab';

import AccountMembersCard from './AccountMembersCard';
import AlertSettingsCard from './AlertSettings/AlertSettingsCard';
import ContactsCard from './Contacts/ContactsCard';
import DemographicsCard from './Demographics/Card';
import DevicesCard from './DevicesCard';
import EMRConnectionsCard from './EMRConnectionsCard';
import IdsCard from './IdsCard';

const messages = defineMessages({
  demographics: {
    id: 'clientTabs.demographics',
    defaultMessage: 'Demographics',
  },
  accountMembers: {
    id: 'clientTabs.accountMembers',
    defaultMessage: 'Account Members',
  },
  ids: {
    id: 'clientTabs.ids',
    defaultMessage: 'IDs',
  },
  contacts: {
    id: 'clientTabs.contacts',
    defaultMessage: 'Key Contacts',
  },
  devices: {
    id: 'clientTabs.devices',
    defaultMessage: 'Health Devices',
  },
  emrConnections: {
    id: 'clientTabs.emrConnections',
    defaultMessage: 'EMR Connections',
  },
  alertSettings: {
    id: 'clientTabs.alertSettings',
    defaultMessage: 'Alert Settings',
  },
});

const ClientTabs: React.FC<{
  user_id: string;
  patient_id?: string;
}> = ({ patient_id, user_id }) => {
  const { formatMessage } = useIntl();

  const nonPatientTabs = [
    { id: 'demographics', value: formatMessage(messages.demographics) },
    { id: 'accountMembers', value: formatMessage(messages.accountMembers) },
  ];
  const tabs = nonPatientTabs.concat([
    { id: 'ids', value: formatMessage(messages.ids) },
    { id: 'contacts', value: formatMessage(messages.contacts) },
    { id: 'devices', value: formatMessage(messages.devices) },
    { id: 'emrConnections', value: formatMessage(messages.emrConnections) },
    { id: 'alertSettings', value: formatMessage(messages.alertSettings) },
  ]);
  const [activeTab, setActiveTab] = useState(
    patient_id ? tabs[0] : nonPatientTabs[0]
  );

  return (
    <>
      <ViewTab
        changeTab={setActiveTab}
        selected={activeTab}
        tabArray={patient_id ? tabs : nonPatientTabs}
      />
      <Container
        sx={{
          margin: '15px auto 30px',
        }}
      >
        <ErrorBoundary FallbackComponent={ErrorBoundaryFallback}>
          {activeTab.id === 'accountMembers' ? (
            <AccountMembersCard user_id={user_id} />
          ) : activeTab.id === 'contacts' ? (
            <ContactsCard />
          ) : activeTab.id === 'ids' ? (
            <IdsCard patient_id={patient_id} />
          ) : activeTab.id === 'devices' ? (
            <DevicesCard user_id={user_id} />
          ) : activeTab.id === 'demographics' ? (
            <DemographicsCard patient_id={patient_id} user_id={user_id} />
          ) : activeTab.id === 'emrConnections' ? (
            <EMRConnectionsCard user_id={user_id} />
          ) : (
            <AlertSettingsCard />
          )}
        </ErrorBoundary>
      </Container>
    </>
  );
};

export default ClientTabs;
